import { Component, ChangeDetectionStrategy } from '@angular/core'
import { RouterModule } from '@angular/router'

@Component({
    selector: 'app-header-blank',
    imports: [RouterModule],
    templateUrl: './header-blank.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header-blank.component.scss',
})
export class HeaderBlankComponent {}
